angular.module('impactx.autoComplete').controller('autoCompleteCtrl', ['$scope', 'TranslationService', '$filter', '$timeout', autocompleteFunction]);

function autocompleteFunction($scope, TranslationService, $filter, $timeout) {
    if (!$scope.noSelectedItemMessage)
    {
        $scope.noSelectedItemMessage = TranslationService.get("noSelectedItemMessage");
    }
    $scope.searchResults = 100;
    $scope.searchText = '';

    $scope.isRequired = function() {
        return $scope.required && !$scope.disabled
    };
    $scope.getItemText = function(entry) {
        if(entry && entry.value) {
            return entry.value;
        }
        else {
            $scope.searchText = null;
            return '';
        }
    };

    $scope.getAutoCompleteValues = function(searchText) {
        return $timeout(function() {
            var results = [];
            if (!searchText) {
                if ($scope.available) {
                    results = $scope.available;
                }
            }
            else {
                if ($scope.filterOnlyValue) {
                    results = $filter('filter')($scope.available, {value: searchText});
                }
                else {
                    results = $filter('filter')($scope.available, searchText);
                }

            }

            var needsFiltering = results.length > $scope.searchResults;
            results = results.slice(0, $scope.searchResults);
            if (needsFiltering) {
                results.push({id: -2, value: TranslationService.get("hasMoreResults")});
            }
            return results;
        });
    };

    $scope.notSelectReadOnly = function (event, selected) {
        if(selected && (selected.readOnly || selected.id < 0)) {
            event.stopPropagation();
            event.preventDefault();
        }
    };

    // this is mostly done on backend anyway, so respect the backend's selection
    if(!$scope.noAutoSelection && $scope.available && $scope.available.length === 1 && !$scope.selected) {
        $scope.selected = $scope.available[0];
        if ($scope.onSelect && typeof $scope.onSelect === 'function') {
            $scope.onSelect({selected: $scope.selected});
        }
    }
}

angular.module('impactx.autoComplete').directive('appAutocomplete', function() {
    return {
        scope: {
            available: "=",
            selected: "=",
            name: "@",
            label: "@",
            requiredLabel: "@",
            dialogData: "=",
            required: "=",
            onSelect: "&",
            ixDisabled: "=",
            placeholder: "@",
            noSelectedItemMessage: "@",
            itemClass: "@",
            noMatchRequired: "=",
            additionalInfo: "@",
            dropDownItems: "=",
            entryTemplate: "=",
            noAutoSelection: "=",
            filterOnlyValue: "="
        },
        restrict: 'E',
        controller: 'autoCompleteCtrl',
        templateUrl: 'shared/autocomplete/templates/appAutocompleteTemplate.html',
        transclude: true
    };
});

angular.module('impactx.autoComplete').directive('mdAutocompleteRequired', function($timeout) {
    return {
        restrict: 'A',
        require: '^form',
        link: function (scope, element, attr, ctrl) {
            scope.$watch(function () {
                return scope.$eval(attr.ngDisabled);
            }, function (newValue, oldValue) {
                if (!angular.equals(newValue, oldValue) || !scope.noMatchRequired) {
                    if (newValue) {
                        scope.searchText = '';
                    }
                    $timeout(function () {
                        var realModel;
                        var oldValid = true;
                        var elemCtrl = ctrl[attr.mdInputName];
                        var realValidation = function (model) {
                            /* tricky validation. gets triggered sometimes two times, so we ignore the second trigger
                             and set it to the old value in some cases.
                             */
                            var isValid = true;
                            if (realModel && model) {
                                isValid = realModel.value === model;
                            }
                            if (model && realModel == null) {
                                isValid = false;
                            }
                            if (realModel == null && model === undefined) {
                                isValid = oldValid;
                            }
                            oldValid = isValid;
                            elemCtrl.$setValidity('selectedItem', isValid);
                            return model;
                        };
                        if (attr.mdSelectedItem && attr.mdInputName && !scope.noMatchRequired) {
                            scope.$watchCollection(attr.mdSelectedItem, function (obj) {
                                realModel = obj;
                                realValidation()
                            });
                            if (elemCtrl) {
                                elemCtrl.$parsers.push(realValidation);
                            }
                        }
                    });
                }
            });
        }
    }
});